

/////////////////////////
// find the invoice added
export const findLastInvoice = (number:string,param:string,invoices:any)=>{
    let lasInvoice = [...invoices].filter((item:any)=>
        validaTypeNumber(item[param]) === validaTypeNumber(number)
    )[0];
    return lasInvoice;
}

export function validaTypeNumber(value1:string){
    let val1 = typeof value1 === 'string' ? +value1 : value1;
    return val1
}